import * as AspectRatio from "@radix-ui/react-aspect-ratio";
import * as Dialog from "@radix-ui/react-dialog";
import { Upload, X } from "lucide-react";
import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { Field } from "./FormControls";
export const ImageDropField = ({
  label,
  error,
  hint,
  required,
  value,
  onChange,
  maxFiles = 5,
}) => {
  const onDrop = useCallback(
    (acceptedFiles) => {
      onChange(acceptedFiles);
    },
    [onChange]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/*": [".jpeg", ".jpg", ".png", ".webp"],
    },
    maxFiles,
  });

  // Add the return statement here
  return (
    <Field label={label} error={error} hint={hint} required={required}>
      <div
        {...getRootProps()}
        className={`border-2 border-dashed rounded-lg p-4 text-center cursor-pointer transition-colors
          ${
            isDragActive
              ? "border-primary bg-primary-50"
              : "border-border-medium hover:border-primary"
          }
        `}
      >
        <input {...getInputProps()} />
        <div className="space-y-2 py-4">
          <Upload className="mx-auto h-12 w-12 text-text-secondary" />
          <div className="text-sm text-text-secondary">
            <span className="text-primary">Click to upload</span> or drag and
            drop
            <br />
            PNG, JPG, JPEG up to {maxFiles} files
          </div>
        </div>
      </div>

      {/* Image Preview Grid */}
      {value && value.length > 0 && (
        <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {Array.from(value).map((file, index) => (
            // <Dialog.Root key={index}>
            //   <Dialog.Trigger asChild>
            <div className="relative group cursor-pointer" key={index}>
              <AspectRatio.Root ratio={1}>
                <img
                  src={
                    file instanceof File
                      ? URL.createObjectURL(file)
                      : file.preview || file
                  }
                  alt={`Preview ${index + 1}`}
                  className="w-full h-full object-cover rounded-lg"
                />
              </AspectRatio.Root>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  const newFiles = Array.from(value).filter(
                    (_, i) => i !== index
                  );
                  onChange(newFiles);
                }}
                className="absolute top-2 right-2 bg-error hover:bg-error-600 text-white p-1.5 rounded-full opacity-100 transition-opacity"
              >
                <X size={16} />
              </button>
            </div>
            // </Dialog.Trigger>

            //   <Dialog.Portal>
            //     <Dialog.Overlay className="fixed inset-0 bg-black/50 backdrop-blur-sm" />
            //     <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 max-w-2xl w-[90vw] max-h-[90vh]">
            //       <Dialog.Title className="sr-only">
            //         Image Preview {index + 1}
            //       </Dialog.Title>
            //       <img
            //         src={URL.createObjectURL(file)}
            //         alt={`Preview ${index + 1}`}
            //         className="w-64 h-64 object-contain rounded-lg"
            //       />
            //       <Dialog.Close asChild>
            //         <button
            //           className="absolute top-2 right-2 p-2 rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors"
            //           aria-label="Close"
            //         >
            //           <X size={20} />
            //         </button>
            //       </Dialog.Close>
            //     </Dialog.Content>
            //   </Dialog.Portal>
            // </Dialog.Root>
          ))}
        </div>
      )}
    </Field>
  );
};
